<!-- 没有手风琴效果的，每一个都独立互相不影响 -->
<template>
	<el-collapse class="component-collapse-menu-picker" v-bind="$attrs">
		<el-collapse-item>
			<template #title>
				<template v-if="!$slots.title">
					<div
						class="flex-1 h-[50px] box-border flex items-center px-5 py-3 bm-size-3_5 leading-6 font-medium cursor-pointer hover:bm-bg-gray-100"
					>
						{{ title }}
					</div>
					<svg
						class="svgfont bm-size-2 absolute right-4"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						width="512"
						height="512"
						viewBox="0 0 512 512"
					>
						<path fill="currentColor" d="M508 112l-252 288-252-288h504z" />
					</svg>
				</template>
				<template v-else>
					<slot name="title" />
				</template>
			</template>

			<template #default>
				<template v-if="!$slots.default">
          <template v-for="item in list">
            <SensorTrack class="flex flex-col" :datas="item.sensorData" v-if="item.show !== false" :key="item.value">
              <nuxt-link-enhance
                :project="item.project"
                :to="item.to"
                :replace="item.replace"
                @click.native="onSelect(item)"
              >
                <span
                  class="px-[30px] box-border flex items-center py-3 bm-size-3_5 leading-6 cursor-pointer hover:bm-bg-gray-100"
                >
                  <span>
                    {{ getTranslate(item.nameLangList, item.name) }}
                  </span>
                  <span
                    class="flex items-center ml-1 px-1 font-medium bm-size-3 leading-4 rounded-sm bm-bg-effect-trans bm-text-effect"
                    v-if="getTranslate(item.labelLangList, item.label)"
                  >
                    {{ getTranslate(item.labelLangList, item.label) }}
                  </span>
									<i class="item-tag" v-if="item.tag">{{item.tag}}</i>
                </span>
              </nuxt-link-enhance>
            </SensorTrack>
          </template>
				</template>
				<template v-else>
					<slot name="default" />
				</template>
			</template>
		</el-collapse-item>
	</el-collapse>
</template>

<script>
import _get from 'lodash/get';
import commonMixins from '../mixins';
import SensorTrack from './SensorTrack';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import i18nMessage from '../i18n';

export default {
	name: 'ComponentsCollapseMenuPicker',
	components: {
		SensorTrack,
		NuxtLinkEnhance,
	},

	mixins: [commonMixins],
	props: {
		title: {
			type: String,
			default: '',
		},
		// { name:'',value:'',to:'',icon:'',show:''}
		list: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {};
	},
	computed: {
		popperClass() {
			return `droplist-menu-popper-class ${this.size}`;
		},
	},
	methods: {
		onSelect(item) {
			if (!item.to) {
				this.$emit('select', item.value);
			}
		},
		getTranslate(langList, defaultValue) {
			const i18nExist = _get(i18nMessage?.[this.$$locale], defaultValue);

			let val = '';
			if (langList?.[this.$$transRouteLocale]) {
				val = langList?.[this.$$transRouteLocale];
			} else if (i18nExist) {
				val = defaultValue;
			} else {
				val = langList?.['en-US'] || defaultValue;
			}

			return val ? this.$t(val) : val;
		},
	},
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';
.component-collapse-menu-picker {
	border: none;

	:deep(.el-collapse-item__arrow) {
		display: none;
	}

	:deep(.el-collapse-item__content) {
		padding-bottom: 0;
	}

	:deep(.el-collapse-item__header) {
		position: relative;
		border-bottom: none;
		height: auto;
		font-weight: 600;
		font-size: 14px;
		line-height: 24px;

		.svgfont {
			transition: transform 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
			transform: rotate(0deg);
		}

		&.is-active {
			.svgfont {
				transform: rotate(180deg);
			}
		}
	}

	:deep(.el-collapse-item__wrap) {
		border-bottom: none;
	}

	:deep(.el-collapse-item:last-child) {
		margin-bottom: 0;
	}
}
.item-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 0 8px;
  background-color: #E5ECF0;
  border-radius: 4px;
  line-height: 22px;
  font-size: 10px;
  font-style: normal;
  vertical-align: middle;
}
</style>
